<template>
  <div>
    <a-card
      style="width:100%"
      :tabList="tabListNoTitle"
      :activeTabKey="tabActive"
      @tabChange="key => onTabChange(key, 'tabActive')"
    >
      <div v-if="tabActive === 'all'">
        <a-table
          :columns="columns"
          :dataSource="data"
          rowKey="id"
          :loading="loading"
          :pagination="pagination"
          @change="handleTableChange">
          <span slot="content" slot-scope="record">{{ record.content }}</span>
          <span slot="id">ID</span>
          <span slot="status" slot-scope="text, record">
            <a-tag v-if="record.status == 0" color="red">未处理</a-tag>
            <template v-else-if="record.status == 1">
              <div v-if="record.result == 0"><a-tag color="green">已处理</a-tag><a-tag color="red">未通过</a-tag></div>
              <div v-else-if="record.result == 1"><a-tag color="green">已处理</a-tag><a-tag color="green">已通过</a-tag></div>
            </template>
          </span>
          <div slot="action" slot-scope="record">
            <a-button type="primary" @click="showModal(record)">查看</a-button>
          </div>
        </a-table>
      </div>
      <div v-else-if="tabActive === 'doNot'">
        <a-table
          :columns="columns"
          :dataSource="data"
          rowKey="id"
          :loading="loading"
          :pagination="pagination"
          @change="handleTableChange">
          <span slot="content" slot-scope="record">{{ record.content }}</span>
          <span slot="id">ID</span>
          <span slot="status" slot-scope="text, record">
            <a-tag v-if="record.status == 0" color="red">未处理</a-tag>
            <template v-else-if="record.status == 1">
              <div v-if="record.result == 0"><a-tag color="green">已处理</a-tag><a-tag color="red">未通过</a-tag></div>
              <div v-else-if="record.result == 1"><a-tag color="green">已处理</a-tag><a-tag color="green">已通过</a-tag></div>
            </template>
          </span>
          <div slot="action" slot-scope="record">
            <a-button type="primary" @click="showModal(record)">查看</a-button>
          </div>
        </a-table>
      </div>
      <div v-else-if="tabActive === 'doDone'">
        <a-table
          :columns="columns"
          :dataSource="data"
          rowKey="id"
          :loading="loading"
          :pagination="pagination"
          @change="handleTableChange">
          <span slot="content" slot-scope="record">{{ record.content }}</span>
          <span slot="id">ID</span>
          <span slot="status" slot-scope="text, record">
            <a-tag v-if="record.status == 0" color="red">未处理</a-tag>
            <template v-else-if="record.status == 1">
              <div v-if="record.result == 0"><a-tag color="green">已处理</a-tag><a-tag color="red">未通过</a-tag></div>
              <div v-else-if="record.result == 1"><a-tag color="green">已处理</a-tag><a-tag color="green">已通过</a-tag></div>
            </template>
          </span>
          <div slot="action" slot-scope="record">
            <a-button type="primary" @click="showModal(record)">查看</a-button>
          </div>
        </a-table>
      </div>
    </a-card>
    <a-modal
      title="查看"
      v-model="visible"
      @ok="handleOk"
      :bodyStyle="bodyStyle"
      width="500px"
      :okText="okText"
      :confirmLoading="confirmLoading"
      centered
    >
      <a-spin :spinning="confirmLoading">
        <div class="text-main">
          <div class="time">
            <span>提交时间：</span>
            <span>{{ detail.create_time }}</span>
            <br>
          </div>
          <div class="description">
            <span>问题描述：</span>
            <span>{{ detail.content }}</span>
          </div>
          <p>建议反馈：</p>
          <a-textarea
            v-if="detail.status == 0"
            v-model="form.solveContent"
            placeholder="请输入建议反馈"
            :autosize="{ minRows: 10 }"/>
          <div v-else>
            {{ detail.solve_content }}
          </div>
        </div>
        <div v-if="detail.status == 0" class="check-div">
          <a-icon
            type="check-circle"
            @click="handleCheckSuggestionStatus(1)"
            :class="{ 'right-active': detail.isActive }"/>
          <a-icon
            type="close-circle"
            @click="handleCheckSuggestionStatus(2)"
            :class="{ 'wrong-active': !detail.isActive }"/>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { getSuggestionList, addSuggestionInfo } from '@/api/manage'

// table表格数据配置
export default {
  data () {
    return {
      bodyStyle: {
        padding: '40px'
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'ID'
        },
        {
          title: '投诉建议',
          dataIndex: 'content',
          key: 'content'
        },
        {
          title: '提交时间',
          dataIndex: 'create_time',
          key: 'create_time'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '查看',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      tabListNoTitle: [
        {
          key: 'all',
          tab: '全部'
        },
        {
          key: 'doNot',
          tab: '待处理'
        },
        {
          key: 'doDone',
          tab: '已采纳'
        }
      ],
      tabActive: 'all',
      data: [],
      detail: {},
      visible: false, // 查看弹出框
      loading: false,
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      form: {
        solveContent: '',
        result: 0
      },
      okText: '提交',
      confirmLoading: false
    }
  },
  mounted () {
    this.handleInitList()
  },
  methods: {
    handleInitList (params = { page: 1, pageSize: 10, status: 2, result: 2 }) {
      this.loading = true
      return getSuggestionList(params)
        .then(res => {
          this.loading = false
          this.data = []
          if (res.result.list !== null && res.result.list.length > 0) {
            res.result.list.forEach((val, key) => {
              val.isActive = false
            })
          }
          this.data = res.result.list ? res.result.list : []
          this.pagination.total = res.result.total
        })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    // tabs切换
    onTabChange (key, type) {
      this[type] = key
      let params = { page: 1, pageSize: 10, status: 2, result: 2 }
      switch (key) {
        case 'all':
          params = { page: 1, pageSize: 10, status: 2, result: 2 }
          break
        case 'doNot':
          params = { page: 1, pageSize: 10, status: 0, result: 2 }
          break
        case 'doDone':
          params = { page: 1, pageSize: 10, status: 1, result: 1 }
          break
      }
      this.handleInitList(params)
    },
    // 查看弹出框
    showModal (record) {
      this.$nextTick(() => {
        this.detail = record
      })
      if (record.status === 0) {
        this.okText = '提交'
      } else {
        this.okText = '确定'
      }
      this.visible = true
    },
    handleOk (e) {
      if (this.detail.status === 0) {
        this.confirmLoading = true
        const params = {
          id: this.detail.id,
          solve_content: this.form.solveContent,
          result: this.form.result
        }
        return addSuggestionInfo(params)
          .then(res => {
            this.$message.success(res.msg)
            this.form.solveContent = ''
            this.handleInitList()
          })
          .catch((err) => this.requestFailed(err))
          .finally(() => {
            this.visible = false
            this.confirmLoading = false
          })
      } else {
        this.visible = false
      }
    },
    requestFailed (err) {
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    handleCheckSuggestionStatus (type) {
      this.form.result = type === 1 ? 1 : 0
      this.detail.isActive = type === 1
    },
    handleTableChange (pagination, filters, sorter) {
      // console.log(pagination)
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      let params = { status: 2, result: 2 }
      switch (this.tabActive) {
        case 'all':
          params = { status: 2, result: 2 }
          break
        case 'doNot':
          params = { status: 0, result: 2 }
          break
        case 'doDone':
          params = { status: 1, result: 1 }
          break
      }
      this.handleInitList({
        pageSize: pagination.pageSize,
        page: pagination.current,
        status: params.status,
        result: params.result,
        ...filters
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .text-area {
    resize: none;
  }

  .description {
    margin: 10px 0 40px;
  }

  .check-div {
    margin: 0px auto;
    margin-top: 40px;
    height: 50px;
    text-align: center;
  }

  .check-div i {
    font-size: 50px;
    margin: 0px 30px;
    color: #ccc;
    cursor: pointer;
  }

  .right-active {
    color: #5daf34 !important;
  }

  .wrong-active {
    color: #f5222d !important;
  }

</style>
